export const contacts =  [
        {
            "img": "https://res.cloudinary.com/rmkt/image/upload/v1597028799/techopps/Group_7_xxzvrp.png",
            "link": "https://www.linkedin.com/company/techopps"
        },
        {
            "img": "https://res.cloudinary.com/rmkt/image/upload/v1597028799/techopps/Group_8_wvsjov.png",
            "link": "https://www.linkedin.com/company/techopps"
        },
        {
            "img": "https://res.cloudinary.com/rmkt/image/upload/v1597028799/techopps/Social_Media_Button-1_fqk6wn.png",
            "link": "https://www.facebook.com/techopps2020/"
        },
        {
            "img": "https://res.cloudinary.com/rmkt/image/upload/v1597028799/techopps/Social_Media_Button_otd0hj.png",
            "link": "https://www.instagram.com/tech.opps/"
        },
    ]
